import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { BaseService } from './base.service';
import { SKIP_LOADING } from '../interceptors/error.interceptor';
import { Pagination } from '../../shared/models/page';
import { 
  DynamicFormListItem, 
  DynamicFormDetails, 
  DynamicFormFilters, 
  CreateDynamicFormRequest 
} from '../../features/formularios/models/dynamic-form';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DynamicFormService extends BaseService<DynamicFormListItem> {
  constructor(protected override http: HttpClient) { 
    super(http, 'dynamic-form'); 
  }

  getList(filters: DynamicFormFilters): Observable<Pagination<DynamicFormListItem>> {
    const params = this.parseHttpParams(filters);
    return this.http.get<Pagination<DynamicFormListItem>>(this.baseApiUrl, {
      params,
      context: new HttpContext().set(SKIP_LOADING, true)
    });
  }

  getFormDetails(id: number): Observable<DynamicFormDetails> {
    return this.http.get<DynamicFormDetails>(`${this.baseApiUrl}/${id}`, {
      context: new HttpContext().set(SKIP_LOADING, true)
    });
  }

  createForm(request: CreateDynamicFormRequest): Observable<DynamicFormDetails> {
    return this.http.post<DynamicFormDetails>(this.baseApiUrl, request, {
      context: new HttpContext().set(SKIP_LOADING, true)
    });
  }

  updateForm(id: number, request: CreateDynamicFormRequest): Observable<void> {
    return this.http.put<void>(`${this.baseApiUrl}/${id}`, request, {
      context: new HttpContext().set(SKIP_LOADING, true)
    });
  }

  deleteForm(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseApiUrl}/${id}`, {
      context: new HttpContext().set(SKIP_LOADING, true)
    });
  }

  publishForm(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseApiUrl}/${id}/publish`, {}, {
      context: new HttpContext().set(SKIP_LOADING, true)
    });
  }

  saveDraft(id: number, request: CreateDynamicFormRequest): Observable<void> {
    return this.http.put<void>(`${this.baseApiUrl}/${id}/draft`, request, {
      context: new HttpContext().set(SKIP_LOADING, true)
    });
  }
}
